enum Color {
	Overflow = 'deepskyblue',
	LiveActivity = '#e32323'
}

export default Color;
